import { Strong } from '@ahmdigital/ui';
import getIncomeTypeFromScale from '@ahmdigital/logic/lib/utils/get-income-type-from-scale';

import styles from './styles.module.sass';

export const getIncomeTypeText = (scale: string | undefined) =>
  getIncomeTypeFromScale(scale) === 'single' ? 'single income' : 'family income';

export const getValueText = (value: number, { max, min }: { max: number; min: number }) => {
  if (value < min) {
    return `Under $${min},000`;
  }
  if (value > max) {
    return `Over $${max},000`;
  }
  return `$${value},000`;
};

type MlsSliderTipProps = {
  limits: {
    max: number;
    min: number;
  };
  scale: string | undefined;
  value: number;
};

const MlsSliderTip = ({ limits, scale, value }: MlsSliderTipProps) => (
  <div>
    <div>
      <Strong variant={styles.value}>{getValueText(value, limits)}</Strong>
    </div>
    <div>{getIncomeTypeText(scale)}</div>
  </div>
);

export default MlsSliderTip;
